import React from 'react';

import { cn } from '@elara/client-core/lib/utils';

export interface LogoProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  variant?: 'full' | 'symbol';
}

export const Logo: React.FC<LogoProps> = ({ className, width = 154, height = 32, variant = 'full' }) => {
  if (variant === 'symbol') {
    return (
      <svg
        width={height}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('inline-block text-accent', className)}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.0001 16.7619C32.0001 25.1776 25.1778 32 16.762 32C16.762 23.5842 23.5844 16.7619 32.0001 16.7619ZM30.2198 19.4141C26.5447 23.8908 23.9684 26.4549 19.408 30.2211C24.8578 29.1558 29.1521 24.863 30.2198 19.4141ZM29.4768 18.5178C23.927 19.5499 19.5521 23.9239 18.5185 29.4732C23.1839 25.6308 25.7318 23.0946 29.4768 18.5178Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 16.7618C8.41573 16.7618 15.2381 23.5842 15.2381 31.9999C6.82239 31.9999 0 25.1776 0 16.7618ZM1.78035 19.4143C2.84809 24.8631 7.14236 29.1557 12.592 30.221C8.03175 26.4549 5.45539 23.891 1.78035 19.4143ZM2.52314 18.5177C6.26831 23.0947 8.81619 25.6309 13.4818 29.4735C12.4483 23.924 8.07311 19.5498 2.52314 18.5177Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.762 0C25.1778 3.15874e-05 32.0001 6.82236 32.0001 15.2381C23.5844 15.2381 16.762 8.41577 16.762 0ZM18.5184 2.52656C19.5519 8.07604 23.927 12.4502 29.477 13.4823C25.7318 8.90534 23.184 6.36912 18.5184 2.52656ZM19.4082 1.77902C23.9685 5.5451 26.5447 8.10906 30.2197 12.5856C29.1519 7.13696 24.8578 2.84432 19.4082 1.77902Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.2381 0C15.2381 8.41576 8.41582 15.238 7.44047e-05 15.238C0.000114053 6.8223 6.82237 2.62434e-05 15.2381 0ZM13.4817 2.52664C8.81627 6.3691 6.26839 8.9053 2.52329 13.4822C8.07314 12.4501 12.4482 8.07602 13.4817 2.52664ZM12.592 1.77902C7.14233 2.84428 2.84799 7.13696 1.78028 12.5858C5.45537 8.10903 8.03176 5.54514 12.592 1.77902Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 154 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('inline-block text-accent', className)}
    >
      <path
        d="M56.1309 6.1709H45.4082V14.7881H55.7744V16.958H45.4082V25.8018H56.1309V27.9727H43.0107V4H56.1309V6.1709ZM66.4004 25.8018H76.3135V27.9727H64.0029V4H66.4004V25.8018ZM103.483 27.9727H100.859L97.3926 19.9062H86.249L82.75 27.9727H80.2559L90.4932 4H93.1816L103.483 27.9727ZM116.581 4C122.833 4.00018 125.619 7.69298 125.619 11.7422C125.619 15.6296 122.703 18.7072 118.492 19.0312L125.263 27.9727H122.25L114.118 17.1201H116.451C120.695 17.1201 123.222 14.9497 123.222 11.6777C123.222 9.41004 121.828 6.1709 116.321 6.1709H111.754V27.9727H109.356V4H116.581ZM153.623 27.9727H150.999L147.532 19.9062H136.389L132.89 27.9727H130.396L140.633 4H143.321L153.623 27.9727ZM87.1562 17.7354H96.4531L91.8535 6.72168L87.1562 17.7354ZM137.296 17.7354H146.593L141.993 6.72168L137.296 17.7354Z"
        fill="var(--color-foreground)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.0001 16.7619C32.0001 25.1776 25.1778 32 16.762 32C16.762 23.5842 23.5844 16.7619 32.0001 16.7619ZM30.2198 19.4141C26.5447 23.8908 23.9684 26.4549 19.408 30.2211C24.8578 29.1558 29.1521 24.863 30.2198 19.4141ZM29.4768 18.5178C23.927 19.5499 19.5521 23.9239 18.5185 29.4732C23.1839 25.6308 25.7318 23.0946 29.4768 18.5178Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 16.7618C8.41573 16.7618 15.2381 23.5842 15.2381 31.9999C6.82239 31.9999 0 25.1776 0 16.7618ZM1.78035 19.4143C2.84809 24.8631 7.14236 29.1557 12.592 30.221C8.03175 26.4549 5.45539 23.891 1.78035 19.4143ZM2.52314 18.5177C6.26831 23.0947 8.81619 25.6309 13.4818 29.4735C12.4483 23.924 8.07311 19.5498 2.52314 18.5177Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.762 0C25.1778 3.15874e-05 32.0001 6.82236 32.0001 15.2381C23.5844 15.2381 16.762 8.41577 16.762 0ZM18.5184 2.52656C19.5519 8.07604 23.927 12.4502 29.477 13.4823C25.7318 8.90534 23.184 6.36912 18.5184 2.52656ZM19.4082 1.77902C23.9685 5.5451 26.5447 8.10906 30.2197 12.5856C29.1519 7.13696 24.8578 2.84432 19.4082 1.77902Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2381 0C15.2381 8.41576 8.41582 15.238 7.44047e-05 15.238C0.000114053 6.8223 6.82237 2.62434e-05 15.2381 0ZM13.4817 2.52664C8.81627 6.3691 6.26839 8.9053 2.52329 13.4822C8.07314 12.4501 12.4482 8.07602 13.4817 2.52664ZM12.592 1.77902C7.14233 2.84428 2.84799 7.13696 1.78028 12.5858C5.45537 8.10903 8.03176 5.54514 12.592 1.77902Z"
        fill="currentColor"
      />
    </svg>
  );
};
